import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import standardAttributeConstants from "../Constants/StandardAttributeConstants";
import StandardAttributeConstants from "../Constants/StandardAttributeConstants";
import AppConstants from "../Constants/AppConstants";

class StandardAttribute_Actions {
  saveUpdateStandardAttribute(attributeData) {
    httpRequest(
      config.webServiceURL + "/Attribute/SaveUpdateStandardAttribute",
      "POST",
      JSON.stringify({
        ID: attributeData.ID,
        Bezeichnung: attributeData.Bezeichnung,
        Type: attributeData.Type,
        Einheit: attributeData.Einheit,
        //IsDropdownMenue: attributeData.IsDropdownMenue,
        NameDisplay: attributeData.NameDisplay,
        IsMandatory: attributeData.IsMandatory,
        QueryId:
          attributeData.QueryId == ""
            ? AppConstants.DEFAULT_GUID
            : attributeData.QueryId,
        Code: attributeData.Code,
        Options: attributeData.Options,
        // WerkID: attributeData.WerkID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.ADDORUPDATE_STANDARD_ATTRIBUTE_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getQueries() {
    httpRequest(
      config.webServiceURL + "/Attribute/GetQueries",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_QUERY_LIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_QUERY_LIST_FAILURE,
          });
        }
      }
    );
  }
  getStandardAttributes() {
    httpRequest(
      config.webServiceURL + "/Attribute/GetStandardAttributes",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_StandardAttribute_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_StandardAttribute_FAILURE,
          });
        }
      }
    );
  }
  deleteAttribute(attributeID) {
    httpRequest(
      config.webServiceURL + "/Attribute/DeleteStandardAttribute",
      "DELETE",

      JSON.stringify([...attributeID]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: StandardAttributeConstants.DELETE_ATTRIBUTE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: StandardAttributeConstants.DELETE_ATTRIBUTE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getAttributeTypes() {
    httpRequest(
      config.webServiceURL + "/Attribute/GetAttributeTypes",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_ATTRIBUTE_TYPE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_ATTRIBUTE_TYPE_FAILURE,
          });
        }
      }
    );
  }

  getOptions(standardAttrId) {
    httpRequest(
      config.webServiceURL + "/WerkAttribute/GetOptions/" + standardAttrId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_ATTRIBUTE_OPTIONS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_ATTRIBUTE_OPTIONS_FAILURE,
          });
        }
      }
    );
  }

  SaveUpdateWerkAttributeOptions(attributeData) {
    httpRequest(
      config.webServiceURL + "/WerkAttribute/SaveUpdateWerkAttributeOptions",
      "POST",
      JSON.stringify({
        StandardattributvorlageId: attributeData.StandardattributvorlageId,
        WerkOptions: attributeData.WerkOptions,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getOptionsListForStandardAttr(equGrpId, standardAttrId) {
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppeStandardAttribute/GetAttributeOptions/" +
        equGrpId +
        "/" +
        standardAttrId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_STANDARD_ATTRIBUTE_OPTIONS_FAILURE,
          });
        }
      }
    );
  }

  getQueryDataResult(queryId, anlagegruppeId) {
    httpRequest(
      config.webServiceURL +
        "/Attribute/GetQueryResult/" +
        queryId +
        "/" +
        anlagegruppeId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_QUERY_DATA_RESULT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: standardAttributeConstants.GET_QUERY_DATA_RESULT_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new StandardAttribute_Actions();
